<template>
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
    <el-breadcrumb-item>工作汇报</el-breadcrumb-item>
    <el-breadcrumb-item>绩效查看</el-breadcrumb-item>
  </el-breadcrumb>
  <el-card>
    
    <el-row>
        <el-col :span="12">
            时间：
  <el-select v-model="value" placeholder="考核年份">
          <el-option
            v-for="item in year"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
        <el-select v-model="value3" placeholder="考核月份">
          <el-option
            label="无"
            value="0">
          </el-option>
          <el-option
            v-for="item in moun"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
    </el-col>
  <el-col :span="2"><div class="grid-content bg-purple"> <el-button type="primary" @click="getPerformance">查询</el-button></div></el-col>
  <el-col :span="2"><div class="grid-content bg-purple"> <el-button type="primary" :disabled="multipleSelection.length<=0" @click="exportExcel">导出Excel</el-button></div></el-col>

</el-row>
<el-table
    ref="multipleTable"
    :data="viewList"
    border
     @selection-change="handleSelectionChange"
    show-overflow-tooltip="true"
    tooltip-effect="dark"
    style="width: 100%"
    >
    <el-table-column
      type="selection"
      width="55">
    </el-table-column>
    <el-table-column
      label="工号"
      width="120"
      :show-overflow-tooltip="true"
      prop="work_number">
      
    </el-table-column>

    <el-table-column
      label="姓名"
      width="120"
      :show-overflow-tooltip="true"
      prop="user_name">
    </el-table-column>
    <el-table-column
      label="教学课时"
      width="120"
      :show-overflow-tooltip="true"
      prop="teaching_hour">
    </el-table-column>
    <el-table-column
      label="听课/辅导课时"
      width="120"
      :show-overflow-tooltip="true"
      prop="lectures_hour">
    </el-table-column>
    <el-table-column
      label="晚自习辅导周周考监考"
      width="190"
      :show-overflow-tooltip="true"
      prop="late_tutor">
    </el-table-column>
    <el-table-column
      label="好/差学生帮扶"
      width="120"
      :show-overflow-tooltip="true"
      prop="student_help">
    </el-table-column>
    <el-table-column
      label="绩效"
      width="120"
      :show-overflow-tooltip="true"
      prop="perf"
      :formatter="perfFormatter">
    </el-table-column>
    <el-table-column
      label="绩效时间"
      width="120"
      :show-overflow-tooltip="true"
      prop="write_date"
      :formatter="writeDateFormatter">
    </el-table-column>
    <el-table-column
      label="提交人"
      width="180"
      :show-overflow-tooltip="true"
      prop="name"
    >
    </el-table-column>
    <el-table-column
      label="生成时间"
      width="120"
      :show-overflow-tooltip="true"
      prop="create_time"
      :formatter="createTimeFormatter">
    </el-table-column>
    <el-table-column
      label="操作" 
      width="320">
      <template slot-scope="scope">
        <el-button   @click="getWeeks(scope.row)">查看详情</el-button>
</template>
    </el-table-column>
</el-table>
  <div class="block">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage4"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="10"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>

  </el-card>

  <el-dialog title="周绩效详情" :visible.sync="dialogTableVisible" width="80%">
    <el-table
    ref="multipleTable"
    :data="weekPerformanceList"
    border
    show-overflow-tooltip="true"
    tooltip-effect="dark"
    style="width: 100%"
    >
    <el-table-column
      label="工号"
      width="120"
      :show-overflow-tooltip="true"
      prop="work_number">
      
    </el-table-column>

    <el-table-column
      label="姓名"
      width="120"
      :show-overflow-tooltip="true"
      prop="user_name">
    </el-table-column>
    <el-table-column
      label="教学课时"
      width="120"
      :show-overflow-tooltip="true"
      prop="teaching_hour">
    </el-table-column>
    <el-table-column
      label="听课/辅导课时"
      width="120"
      :show-overflow-tooltip="true"
      prop="lectures_hour">
    </el-table-column>
    <el-table-column
      label="晚自习辅导周周考监考"
      width="190"
      :show-overflow-tooltip="true"
      prop="late_tutor">
    </el-table-column>
    <el-table-column
      label="好/差学生帮扶"
      width="120"
      :show-overflow-tooltip="true"
      prop="student_help">
    </el-table-column>
    <el-table-column
      label="周次"
      width="120"
      :show-overflow-tooltip="true"
      prop="is_weeks">
    </el-table-column>
    <el-table-column
    label="备注"
    width="120"
    :show-overflow-tooltip="true"
    prop="remark">
  </el-table-column>
    <el-table-column
      label="绩效时间"
      width="120"
      :show-overflow-tooltip="true"
      prop="write_date"
      :formatter="writeDateFormatter2">
    </el-table-column>
    <el-table-column
      label="生成时间"
      width="180"
      :show-overflow-tooltip="true"
      prop="create_time"
      :formatter="createTimeFormatter2">
    </el-table-column>
    <el-table-column
      label="操作" 
      width="320">
      <template slot-scope="scope">
        <el-button   @click="viewFile(scope.row)">查看文件</el-button>
</template>
    </el-table-column>
</el-table>

<el-dialog
      width="60%"
      title="图片显示"
      :visible.sync="innerVisible"
      append-to-body>
     <!-- <div v-for="item in imageList">
      <el-image 
    style="width: 40%; "
    :src="item" 
    :preview-src-list="imageList">
  </el-image>
     </div> -->
     <el-image v-for="url in imageList" :key="url" :src="url" :preview-src-list="imageList" lazy></el-image>
    </el-dialog>
</el-dialog>


</div>
</template>

<script>
export default {
  created(){
    this.getYearDateList()
    this.getMonthlIST()
    this.getPerformance()
  },
data(){
    return{
      imageList:[],
      dialogTableVisible:false,
      innerVisible:false,
      multipleSelection:[],
      weekPerformanceList:[],
        year:[],
        moun:[],
        userType:'getTPerformance',
        value: '',
        value3: '',
        viewList:[],
        formData:{
            particulars:'',
            fileList7:[],
          fileList8:[],
          fileList:[],
            is_public:false,
            file:null
        },
        querys:{
         writeDate:null,
          pageNum:null,
          pageSize:null,
          isWeeks:4,
          isYear:'false'
        },
        total:null,
        currentPage4: 1,
    }
},methods:{
  exportExcel(){
    this.axios({
url: "/performance/teacher/exportExcel",   //后端地址
method: "post",
data:this.multipleSelection, //请求参数
headers: {  
'Access-Control-Allow-origin': '*', 'Content-Type': 'application/json; charset=UTF-8',
},
// contenType:'application/json',
responseType: "blob"
})
.then(res => {
  // let fileNames = decodeURI((res.headers['content-disposition'].split("="))[1])
    console.log('res.headers',res.headers)
  const blob = new Blob([res.data]);
 let data= new Date().toLocaleString()
   const fileName = "绩效-"+data+".xlsx"; 
    const elink = document.createElement("a");
    elink.download = fileName;
    elink.style.display = "none";
    elink.href = URL.createObjectURL(blob);
    document.body.appendChild(elink);
    elink.click();
    URL.revokeObjectURL(elink.href); // 释放URL 对象
    document.body.removeChild(elink); 
    this.selectData=false
})
},perfFormatter(row,column,cellValue,index){
   let datas= cellValue*100+'%'
  return datas
  },
viewFile(row){
  console.log(this.$imagepath)
this.innerVisible=true
let list=JSON.parse(row.annex_file_url)
list=list.map(element => {
  return this.$imagepath+element
});
this.imageList=list
},
    handleSizeChange(val) {
        if(val!=null||val!=''){
          this.querys.pageSize=val
        }
        console.log(`每页 ${val} 条`);
        this.getPerformance()
      },  handleSelectionChange(val) {
        this.multipleSelection = val;
        console.log(this.multipleSelection)
      },
      handleCurrentChange(val) {
        if(val!=null||val!=''){
          this.querys.pageNum=val
        }
        console.log(`当前页: ${val}`);
        this.getPerformance()
      },
    getPerformance(){
      let moundVal=0;
      if(this.value3=='0'){  
        this.querys.isYear='true'
        moundVal=1
      }else{
        this.querys.isYear='false'
        moundVal=this.value3
      }
        let kpidate=this.value+'-'+(moundVal>9?moundVal:'0'+moundVal)
        this.querys.writeDate=kpidate
    this.axios.get("/performance/"+this.userType+this.$formateDate.tansParams(this.querys))
             .then(resp=>{
              console.log(resp)
              if(resp.data.status==1){
                console.log(resp.data.result)
                this.total=resp.data.result.total
                this.viewList=resp.data.result.rows
                console.log('this.viewList',this.viewList)
              }
             })
  },writeDateFormatter(row,column,cellValue,index){
    var date =	new Date(cellValue);
   let year= date.getFullYear()
   let month= date.getMonth()+1
   this.viewList[index].write_date=year+'/'+month
  return year+'/'+month
  },createTimeFormatter(row,column,cellValue,index){
    var date =	new Date(cellValue).toLocaleString();
    this.viewList[index].create_time=date
  return date
  },writeDateFormatter2(row,column,cellValue,index){
    var date =	new Date(cellValue);
   let year= date.getFullYear()
   let month= date.getMonth()+1
   this.weekPerformanceList[index].write_date=year+'/'+month
  return year+'/'+month
  },createTimeFormatter2(row,column,cellValue,index){
    var date =	new Date(cellValue).toLocaleString();
    this.weekPerformanceList[index].create_time=date
  return date
  },
  getYearDateList(){
      var date = new Date()
    var Y = date.getFullYear()
   let yearList=[]
   yearList.push(Y-1)
   yearList.push(Y)
   yearList.push(Y+1)
    this.value=Y
   this.year=yearList
       },   getMonthlIST(){
        var date = new Date()
        var M = (date.getMonth() + 1)
 
        this.value3=M
      
        let mounList=[]
        for (let index = 1; index <13; index++) {
        mounList.push(index)  
        }
      this.moun=mounList
      // this.value3=M
       },getWeeks(row){
        console.log(row)
        this.axios.get("/performance/getTPerformanceByPerfId?perfId="+row.id)
             .then(resp=>{
              console.log(resp)
              if(resp.data.status==1){
                console.log(resp.data)
         this.weekPerformanceList=resp.data.result
         this.dialogTableVisible=true
              }
             })
       },

      
      
      
}

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/work/leader/viewPerformance.vue